jQuery(function($){
  $(document).on('nfFormSubmitResponse', function(event, response){
    if (response.id == '4' && response.response.errors.length == 0){
      $('.document-form__download').removeClass('m--hidden');
    }
  });
});
